<template>
  <div class="pb-2">
    <div class="pt-4">
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative" id="documents-search-userfilter">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
          $t("message.loginComponent.languagesVuetify.user") }}</label>
        <div>
          <div>
            <MultiSelect @search-change="findEmployee" :value="selectedEmployee" @input="setSelectedEmployee"
              :options="employeeItems" :searchable="true" :label="$t('message.inicioComponent.name')" :multiple="true"
              :internal-search="false" :clear-on-select="true" :close-on-select="false" :loading="isLoading"
              :preserve-search="false" :tag-placeholder="$t('message.searchComponent.form_select')" :show-labels="false"
              :show-no-options="false" placeholder="" track-by="id">
              <template slot="noResult"><span class="multiselect__single">{{
                $t('message.searchComponent.not_founded')
                  }}</span></template>
              <template slot="maxElements"><span class="multiselect__single">{{
                $t('message.searchComponent.max_elements')
                  }}</span></template>
              <template #tag="{ remove, option }">
                <CustomChip @click="remove(option)">{{
                  option.nombre
                  }}</CustomChip>
              </template>

              <template #caret>
                <span class="hidden"></span>
              </template>
            </MultiSelect>
          </div>
        </div>
      </div>
      <p class="py-2 text-zt-dark-300 text-zt-xs">
        {{ $t('message.label.userHint') }}
      </p>
    </div>
    <ValidationProvider rules="numeric|max:20" v-slot="{ errors }">
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative mt-2">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">
          {{ $t('message.searchComponent.fileNumber') }}</label>
        <div>
          <zt-input ref="fileNumber" v-model="fileNumber" @input="setFileNumber" color="#E0E0E0" name="fileNumber"
            data-vs-input="fileNumber" />
        </div>
      </div>
      <span class="error-message text-zt-danger text-base" v-show="errors[0]">
        {{ $t('message.searchComponent.fileNumberInvalid') }}</span>
    </ValidationProvider>
    <div class="pt-4">
      <div>
        <div class="border border-zt-dark-300 rounded px-2 pt-1 relative" id="documents-search-documenttypefilter">
          <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
            $t("message.settingsComponent.list.FileUploadComponent.documentSelectLabel") }}</label>
          <MultiSelect :value="selectedFolder" @input="setSelectedSubFolder" :options="foldersItems" :multiple="true"
            track-by="id" label="name" :clear-on-select="true" :close-on-select="false" :show-labels="false"
            :show-no-options="false" placeholder="">
            <template slot="noResult"><span class="multiselect__single">{{
              $t('message.searchComponent.not_founded')
                }}</span></template>
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option.name }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
    <div>
      <DateFilter @signed-date="setSignedFilters" />
    </div>
    <div>
      <div class="border border-zt-dark-300 rounded px-2 pt-1 relative" id="documents-search-statefilter">
        <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
          $t("message.workflow.table.columns.status") }}</label>
        <div>
          <MultiSelect :value="statusSelected" @input="setStatusSelected" :options="statusOpts" :searchable="true"
            :multiple="true" :internal-search="false" :clear-on-select="true" :close-on-select="false"
            :preserve-search="false" :show-labels="false" :show-no-options="false" placeholder="">
            <template slot="noResult"><span class="multiselect__single">{{
              $t('message.searchComponent.not_founded')
                }}</span></template>
            <template slot="maxElements"><span class="multiselect__single">{{
              $t('message.searchComponent.max_elements')
                }}</span></template>
            <template #tag="{ remove, option }">
              <CustomChip @click="remove(option)">{{ option }}</CustomChip>
            </template>
          </MultiSelect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/apiClient/Search'
import Folders from '@/apiClient/Folders'
import MultiSelect from 'vue-multiselect'
import CustomChip from './CustomChip'
import DateFilter from './DateFilter'
import { addFilters } from '../utils'
import { flatten, map, isEmpty, filter, flatMap, some, reduce } from 'lodash'
import addGTMClass from '@/utils/addGTMClass'

export default {
  name: 'SearchMainSection',
  components: {
    MultiSelect,
    CustomChip,
    DateFilter
  },
  inject: ['store', 'setFilters', 'setFoldersItems'],
  data() {
    return {
      gtmIds: [
        'documents-search-userfilter',
        'documents-search-documenttypefilter',
        'documents-search-statefilter'
      ],
      employeeItems: [],
      subFoldersEforms: [],
      isLoading: false,
      selectedEmployee: '',
      fileNumber: '',
      foldersItems: [],
      selectedFolder: '',
      foldersConfig: new Folders(),
      searchConfig: new Search(),
      signedFilters: '',
      statusSelected: [],
      statusValue: {
        [this.$t("message.DocumentsComponents.statusSigned.signedConformed")]: 'FIRMADO CONFORME',
        [this.$t("message.DocumentsComponents.statusSigned.noSigned")]: 'NO FIRMADO',
        [this.$t("message.DocumentsComponents.statusSigned.signedDisconformed")]: 'FIRMADO DISCONFORME',
        [this.$t("message.DocumentsComponents.statusSigned.noRequiredSignature")]: 'NO REQUIERE FIRMA',
        [this.$t("message.DocumentsComponents.statusSigned.rejected")]: 'RECHAZADO',
        [this.$t("message.DocumentsComponents.statusSigned.pendingApproval")]: 'PENDIENTE APROBACION'
      },
      statusOpts: [
        this.$t("message.DocumentsComponents.statusSigned.signedConformed"),
        this.$t("message.DocumentsComponents.statusSigned.noSigned"),
        this.$t("message.DocumentsComponents.statusSigned.signedDisconformed"),
        this.$t("message.DocumentsComponents.statusSigned.noRequiredSignature"),
        this.$t("message.DocumentsComponents.statusSigned.rejected"),
        this.$t("message.DocumentsComponents.statusSigned.pendingApproval"),
      ]
    }
  },
  async created() {
    try {
      const responseFolders = await this.foldersConfig.getFoldersAndEforms()

      const {
        data: { data }
      } = responseFolders

      this.subFoldersEforms = flatMap(
        filter(data, { type: 'eforms' }),
        subFolder => subFolder.childs
      )

      this.foldersItems = flatten(map(data, 'childs'))
      this.setFoldersItems(data)
    } catch (error) {
      this.foldersItems = []
    }
    if (this.$route.params.loadUnsignedDocs) { this.setStatusSelected(['NO FIRMADO']) }
  },
  mounted() {
    addGTMClass(this.gtmIds)
  },
  methods: {
    setStoreFilter(key, input) {
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, [key, input])
      this.setFilters(newFilters)
    },
    async findEmployee(key) {
      try {
        if (key.length >= 3) {
          const response = await this.searchConfig.SearchEmployee(key)

          const {
            data: { data }
          } = response

          this.employeeItems = data
        }
      } catch (error) {
        this.employeeItems = []
      }
    },

    setSelectedEmployee(value) {
      this.selectedEmployee = value
      if (this.selectedEmployee) {
        const { filters } = this.store
        const newFilters = addFilters({ ...filters }, [
          'userId',
          map(this.selectedEmployee, 'id')
        ])
        this.setFilters(newFilters)
      }
    },

    setSelectedSubFolder(value) {
      this.selectedFolder = value
      if (this.selectedFolder) {
        const { filters } = this.store

        const foldersDocuments = reduce(
          this.selectedFolder,
          (acc, folder) => {
            if (!some(this.subFoldersEforms, { id: folder.id }))
              acc.push(folder.id)

            return acc
          },
          []
        )

        const eformsDocuments = reduce(
          this.selectedFolder,
          (acc, folder) => {
            if (some(this.subFoldersEforms, { id: folder.id }))
              acc.push(folder.id)

            return acc
          },
          []
        )

        const newFilters = addFilters(
          { ...filters },
          ['subFolderId', foldersDocuments],
          ['eform', eformsDocuments]
        )
        this.setFilters(newFilters)
      }
    },

    setSignedFilters(value) {
      const { signed } = value
      if (signed && !isEmpty(signed)) {
        const { filters } = this.store
        const newFilters = addFilters(
          { ...filters },
          ['periodFrom', signed.start],
          ['periodTo', signed.end]
        )
        this.setFilters(newFilters)
      }
    },
    setFileNumber(value) {
      this.fileNumber = value
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, ['fileNumber', value])
      this.setFilters(newFilters)
    },
    setStatusSelected(value) {
      this.statusSelected = value
      const signStatusValue = this.getStatusValue(value)
      this.setStoreFilter('signStatus', [...signStatusValue])
    },
    getStatusValue(value) {
      return value.map(status => this.statusValue[status])
    }
  }
}
</script>
<style>
.top--negative__8 {
  top: -8px;
}

.multiselect__content-wrapper {
  width: fit-content;
  min-width: 100%;
  border: none;
}

.multiselect__tags {
  border: none;
  padding: 8px 38px 6px 0;
}

.multiselect__select {
  padding-left: 16px;
}

::v-deep .zt-input-focused {
  color: transparent;
}
</style>
